import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VTooltip = _resolveComponent("VTooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" TODO - this needs to implement all other cases "),
    _createVNode(_component_VTooltip, {
      ref: "tooltipRef",
      activator: "parent",
      class: "iconn_tooltip",
      location: $props.location,
      disabled: $setup.disabledTooltip,
      "max-width": $props.maxWidth,
      eager: false
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString($props.text) + " ", 1 /* TEXT */),
        _renderSlot(_ctx.$slots, "content")
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["location", "disabled", "max-width"])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}